module.exports = __webpack_public_path__ + "img/PageFooter.50ad0611.png";